/**
 * Alpine component: subscriptionDiscipline
 *
 * Cambio della professione/disciplina con cui l'utente segue un corso,
 * dalla sidebar della scheda di fruizione ("In qualità di").
 * Le opzioni sono le professioni dell'utente ammesse per il corso
 * (available_disciplines di /training); il PATCH le rivalida lato API.
 *
 * API: PATCH /v1/users/me/subscriptions/:id { discipline_id, occupation_id }
 */
export function registerSubscriptionDiscipline(Alpine) {
    Alpine.data('subscriptionDiscipline', (config) => ({
        subscriptionId: config.subscriptionId,
        options: config.options || [],
        current: config.current || null,
        editing: false,
        saving: false,
        error: '',
        // Valore della select: "occupationId:disciplineId", la coppia è la chiave
        selected: '',

        get canEdit() {
            return this.options.length > 1;
        },

        get currentLabel() {
            return this.labelFor(this.current);
        },

        keyFor(option) {
            if (!option) return '';
            return option.occupation.id + ':' + option.id;
        },

        labelFor(option) {
            if (!option) return '';
            const occupation = option.occupation?.name || '';
            const discipline = option.name || '';
            if (!discipline || discipline === occupation) return occupation;
            return occupation + ' / ' + discipline;
        },

        open() {
            this.error = '';
            this.selected = this.keyFor(this.current);
            this.editing = true;
            this.$nextTick(() => this.$refs.select?.focus());
        },

        cancel() {
            this.editing = false;
            this.error = '';
        },

        async save() {
            if (this.saving) return;
            const option = this.options.find(o => this.keyFor(o) === this.selected);
            if (!option) {
                this.error = 'Seleziona una professione';
                return;
            }
            if (this.keyFor(option) === this.keyFor(this.current)) {
                this.editing = false;
                return;
            }

            this.saving = true;
            this.error = '';
            try {
                const data = await this._apiPatch('/v1/users/me/subscriptions/' + this.subscriptionId, {
                    discipline_id: option.id,
                    occupation_id: option.occupation.id,
                });
                this.current = data.discipline || option;
                this.editing = false;
                window.dispatchEvent(new CustomEvent('show-toast', {
                    detail: { type: 'success', message: 'Professione aggiornata: ' + this.currentLabel },
                }));
            } catch (err) {
                const messages = err?.validation_messages?.discipline_id;
                this.error = messages
                    ? Object.values(messages)[0]
                    : (err?.detail || 'Aggiornamento non riuscito, riprova');
            } finally {
                this.saving = false;
            }
        },

        async _apiPatch(path, body) {
            const apiBase = window.IKOS?.apiBase || '';
            const headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            };
            const authToken = window.IKOS?.authToken;
            if (authToken && authToken !== true) headers['Auth-Token'] = authToken;

            const res = await fetch(apiBase + path, {
                method: 'PATCH',
                headers,
                body: JSON.stringify(body),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw data;
            return data;
        },
    }));
}
